import { useState } from 'react';
import useAuthStore from '../../stores/authStore';
import NavAuthButton from './navigation/NavAuthButton';
import NavBrand from './navigation/NavBrand';
import NavTargetLink from './navigation/NavTargetLink';
import {
  ADMIN_LINK,
  CONTACT_LINK,
  HOME_LINK,
  KPI_LINK,
  PROJECTEN_LINK,
  WERKINSTRUCTIES_LINK,
} from './navigation/navigationConfig';
import './navigation/navigation.css';

function NavSectionLink({ target, onNavigate }) {
  return (
    <NavTargetLink target={target} className="c-navigation__item w-nav-link" onNavigate={onNavigate}>
      {target.label}
    </NavTargetLink>
  );
}

function Navbar() {
  const { isAuthenticated, role } = useAuthStore();
  const [mobileOpen, setMobileOpen] = useState(false);

  const closeMobile = () => setMobileOpen(false);

  return (
    <header className="c-nav-bar" data-page-guide="">
      <div className="c-nav-bar__inner">
        <NavBrand onNavigate={closeMobile} />

        <button
          type="button"
          className="c-nav-bar__toggle"
          aria-expanded={mobileOpen}
          aria-controls="main-navigation"
          onClick={() => setMobileOpen((open) => !open)}
        >
          <span className="c-nav-bar__toggle-label">{mobileOpen ? 'Sluiten' : 'Menu'}</span>
        </button>

        <nav
          id="main-navigation"
          role="navigation"
          className={`c-navigation w-nav-menu${mobileOpen ? ' is-open' : ''}`}
        >
          <NavSectionLink target={HOME_LINK} onNavigate={closeMobile} />
          <NavSectionLink target={PROJECTEN_LINK} onNavigate={closeMobile} />
          {isAuthenticated && (
            <>
              <NavSectionLink target={CONTACT_LINK} onNavigate={closeMobile} />
              <NavSectionLink target={WERKINSTRUCTIES_LINK} onNavigate={closeMobile} />
              {role === 'admin' && (
                <>
                  <NavSectionLink target={ADMIN_LINK} onNavigate={closeMobile} />
                  <NavSectionLink target={KPI_LINK} onNavigate={closeMobile} />
                </>
              )}
            </>
          )}
          <NavAuthButton onNavigate={closeMobile} />
        </nav>
      </div>
    </header>
  );
}

export default Navbar;
